import React, { Component, Fragment } from 'react'
import { BASE_URL } from '../../config'

import ComboBox from '../../components/atoms/ComboBox';
import TextBox from '../../components/atoms/TextBox';
import LabelWithInput from '../../components/molecules/LabelWithInput';

//Region 
export const get_provinsi = '/customer-informations/postal-codes/provinces';
export const get_kota = (prov) => `/customer-informations/postal-codes/provinces/${prov}/cities`
export const get_kecamatan = (prov, city) => `/customer-informations/postal-codes/provinces/${prov}/cities/${city}/subdistricts`
export const get_kelurahan = (prov, city, subdis) => `/customer-informations/postal-codes/provinces/${prov}/cities/${city}/subdistricts/${subdis}/villages`


export class FormRegion extends Component {
	_isMounted = false;
    
    constructor(props){
        super(props);
        this.state = {
            provinsi : { list : [], selected : 0, loading : false },
            kota : { list : [], selected : 0, loading : false },
            kecamatan : { list : [], selected : 0, loading : false },
            kelurahan : { list : [], selected : 0, loading : false },
            kode_pos : '',
            isComplete : false
        }
    }

    resetState = (index) => {
        // For reset some state even change value
        const resetValue = { list : [], selected : 0, loading : false };
        switch (index) {
            case 1 : 
                this.setState({
                    kota : resetValue,
                    kecamatan : resetValue,
                    kelurahan : resetValue
                });
                this.props.changeState({ name : 'city', value : { city : null, cityCode : null}})
                this.props.changeState({ name : 'subdistrict', value : { subdistrict : null, subdistrictCode : null}})
                this.props.changeState({ name : 'addressKel', value : { addressKel : null, addressKelCode : null}})

                // this.props.changeState({name : 'city', value : null})
                // this.props.changeState({name : 'cityCode', value : null})
                // this.props.changeState({name : 'subdistrict', value : null})
                // this.props.changeState({name : 'subdistrictCode', value : null})
                // this.props.changeState({name : 'addressKel', value : null})
                // this.props.changeState({name : 'addressKelCode', value : null})
            break;
            case 2 : 
                this.setState({
                    kecamatan : resetValue,
                    kelurahan : resetValue
                });
                // this.props.changeState({ name : 'city', value : { city : null, cityCode : null}})
                this.props.changeState({ name : 'subdistrict', value : { subdistrict : null, subdistrictCode : null}})
                this.props.changeState({ name : 'addressKel', value : { addressKel : null, addressKelCode : null}})
                // this.props.changeState({name : 'subdistrict', value : null})
                // this.props.changeState({name : 'subdistrictCode', value : null})
                // this.props.changeState({name : 'addressKel', value : null})
                // this.props.changeState({name : 'addressKelCode', value : null})
            break;
            case 3 : 
                this.setState({
                    kelurahan : resetValue
                });
                // this.props.changeState({name : 'addressKel', value : null})
                // this.props.changeState({name : 'addressKelCode', value : null})
                // this.props.changeState({ name : 'city', value : { city : null, cityCode : null}})
                // this.props.changeState({ name : 'subdistrict', value : { subdistrict : null, subdistrictCode : null}})
                this.props.changeState({ name : 'addressKel', value : { addressKel : null, addressKelCode : null}})
            break;
            default : break;
        }
        this.setState({kode_pos : '', isComplete : false});
        this.props.changeState({name : 'postalCode', value : null})
    }

    changeHandler = ({target, nativeEvent}) => {
        let urlFetch = BASE_URL;
        const {provinsi, kota, kelurahan} = this.state;

        const index = nativeEvent.target.selectedIndex;
        const text = nativeEvent.target[index].text
        // console.log("ngambil text -- ",nativeEvent.target[index].text) //ini outputnya texxt yang dipilih

        const {name, value} = target;
        console.log({name, value, text});
        
        this.setStateList(name, 'selected', value);
        switch(name){
            case 'provinsi' : 
                urlFetch += get_kota(value);
                this.props.changeState({ name : 'province', value : { province : text, provinceCode : value}})
                // this.props.changeState({name : 'province', value : text})
                // this.props.changeState({name : 'provinceCode', value})
                this.getSetData('kota', urlFetch);
                this.resetState(1);
                break;
            case 'kota' :
                urlFetch += get_kecamatan(provinsi.selected, value)
                this.props.changeState({ name : 'city', value : { city : text, cityCode : value}})

                // this.props.changeState({name : 'city', value : text})
                // this.props.changeState({name : 'cityCode', value})
                this.getSetData('kecamatan', urlFetch);
                this.resetState(2);
                break;
            case 'kecamatan' :
                urlFetch += get_kelurahan(provinsi.selected, kota.selected, value);
                this.props.changeState({ name : 'subdistrict', value : { subdistrict : text, subdistrictCode : value}})
                
                // this.props.changeState({name : 'subdistrict', value : text})
                // this.props.changeState({name : 'subdistrictCode', value})
                this.getSetData('kelurahan', urlFetch);
                this.resetState(3);
                break;
            case 'kelurahan' :
                this.props.changeState({ name : 'addressKel', value : { addressKel : text, addressKelCode : value}})

                // this.props.changeState({name : 'addressKel', value : text})
                // this.props.changeState({name : 'addressKelCode', value})
                const selected = kelurahan.list.filter(data => (data.id === Number(value)));
                this.props.changeState({name : 'postalCode', value : selected[0].postalCode})
                this._isMounted && this.setState({kode_pos : selected[0].postalCode, isComplete : true});
                break;
            default : break;
        }
    }


    getSetData = async (name, url) => {
        // this.setStateList(name, 'loading', true);

        let pathResult;
        switch(name){
            case 'provinsi' :   pathResult = 'provinces'; break;
            case 'kota' :       pathResult = 'cities'; break;
            case 'kecamatan' :  pathResult = 'subdistricts'; break;
            case 'kelurahan' :  pathResult = 'urbanVillages'; break;
            default : break;
        }

        const res = await fetch(url);
        const hasil = await res.json();
        this.setStateList(name, 'loading', false);
        // console.log("cari kelurahan == ", hasil.result[pathResult]);
        
        (res.status === 200) ? this.setStateList(name, 'list', hasil.result[pathResult]) : console.error(hasil.status.message);
    }

    setStateList = (parent, child, value) => {
        // console.log("cari yang kota = ", {parent, child, value});
        
        if (this._isMounted) {
            let parents = this.state[parent]
            if(parents){
                parents[child] = value
                if (this._isMounted) {
                    this.setState({
                        [parent] : parents
                    })
                }
            }
        }
    }

    setData = () => {
        let urlFetch = BASE_URL;
        let { data } = this.props
        const {provinsi, kota, kelurahan} = this.state;
        // console.log("masuk set data = ", data);
        let {provinceCode, cityCode, subdistrictCode, addressKelCode, postalCode, province, city, subdistrict, addressKel} = data
        provinceCode = provinceCode || province
        cityCode = cityCode || city
        subdistrictCode = subdistrictCode || subdistrict
        addressKelCode = addressKelCode || addressKel
        // console.log({provinceCode, cityCode, subdistrictCode, addressKelCode, postalCode, province, city, subdistrict, addressKel});
        

        if(provinceCode){
            this.setStateList('provinsi', 'selected', provinceCode);
            urlFetch += get_kota(provinceCode);
            this.getSetData('kota', urlFetch);
            if(cityCode){
                urlFetch = BASE_URL;
                this.setStateList('kota', 'selected', cityCode);
                // console.log("masuk sini city");
                
                urlFetch += get_kecamatan(provinceCode, cityCode)
                this.getSetData('kecamatan', urlFetch);
                if(subdistrictCode){
                    urlFetch = BASE_URL
                    this.setStateList('kecamatan', 'selected', subdistrictCode);
                    urlFetch += get_kelurahan(provinceCode, cityCode, subdistrictCode);
                    this.getSetData('kelurahan', urlFetch);
                    if(addressKelCode){                      
                        this.setStateList('kelurahan', 'selected', addressKelCode);
                        // const selected = kelurahan.list.filter(data => (data.id === Number(addressKelCode)));
                        // console.log({selected, listKel : kelurahan.list, addressKelCode});
                        
                        this.setState({kode_pos : postalCode, isComplete : true});
                    }
                }
            }
        }
    }
    componentDidMount = () => {
        this._isMounted = true;
        if(this._isMounted){
            this.getSetData('provinsi', BASE_URL+get_provinsi);
            this.setData()
        }

    }

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    render() {
        const {provinsi, kota, kecamatan, kelurahan, kode_pos} = this.state;
        return (
            <Fragment>
                {/* Province */}
                <LabelWithInput col={this.props.col} label='Provinsi'>
                    <ComboBox fieldName={{value : 'id', text : 'provinceName'}} name='provinsi' isLoading={provinsi.loading} value={provinsi.selected} title='Provinsi' data={provinsi.list} onChange={e => this.changeHandler(e)} />
                </LabelWithInput>

                {/* Kota / Kabupaten */}
                <LabelWithInput col={this.props.col} label='Kota / Kabupaten'>
                    <ComboBox fieldName={{value : 'id', text : 'cityName'}} name='kota' isLoading={kota.loading} value={kota.selected} title='Kota' data={kota.list} onChange={e => this.changeHandler(e)} />
                </LabelWithInput>

                {/* Kecamatan */}
                <LabelWithInput col={this.props.col} label='Kecamatan'>
                    <ComboBox fieldName={{value : 'id', text : 'subdistrictName'}} name='kecamatan' isLoading={kecamatan.loading} value={kecamatan.selected} title='Kecamatan' data={kecamatan.list} onChange={e => this.changeHandler(e)} />
                </LabelWithInput>
                
                {/* Kelurahan */}
                <LabelWithInput col={this.props.col} label='Kelurahan'>
                    <ComboBox fieldName={{value : 'id', text : 'villageName'}} name='kelurahan' isLoading={kelurahan.loading} value={kelurahan.selected} title='Kelurahan' data={kelurahan.list} onChange={e => this.changeHandler(e)} />
                </LabelWithInput>

                {/* Kode POS */}
                <LabelWithInput col={this.props.col} label='Kode POS'>
                    <TextBox onChange={e => {this.onChangeHandler(e)}} value={kode_pos} name='kode_pos' type='text' isDisabled={true} /> 
                </LabelWithInput>
            </Fragment>
        )
    }
}


export default FormRegion;
